import $ from "jquery";
export class vasilkovModule {

    constructor(event, slick, statement, currentSlide, nextSlide) {
		statement === "init"
			? this.handleInit(slick)
			: (statement === "beforeChange"
				? this.handleBeforeChange(slick, currentSlide, nextSlide)
				: (statement === "afterChange"
					? this.handleAfterChange(slick)
					: this.Vasilkov()));
	}
	private Vasilkov = () => {
		
		setTimeout(function () {
			$('.hero').css('opacity', '1');
		}, 900)
	}
	private handleInit(slick) {
        for (var i = 0; i < slick.$slides.length; i++) {
			$('.count').append('<li> 00' + (i + 1) + ' </li>');
			$('.big-count').append('<li> <p>0</p><p>0</p><p>' + (i + 1) + '</p></li>');
            $('.count-length').text('- 00' + (i + 1) + '');
            
			if ((i + 1) == slick.$slides.length) {
				var CurrentSlide = $('#hero-slider').find('.slick-current').index();
				$('.count li').removeClass('active')
				$('.count li').removeClass('done')
				$('.count li').eq(CurrentSlide).addClass("active");
				$('.count li').eq(CurrentSlide).next().addClass("done");
				$('.big-count li').eq(CurrentSlide).addClass("active");
				$('.big-count li').eq(CurrentSlide).next().addClass("done");
            }
                       
        };
	}
	private handleAfterChange(slick) {
		var CurrentSlide = $('#hero-slider').find('.slick-current').index();

		$('.count li').removeClass('active')
		$('.count li').removeClass('done')
		$('.big-count li').removeClass('active')
		$('.big-count li').removeClass('done')
		$('.count li').eq(CurrentSlide).addClass("active");
		$('.big-count li').eq(CurrentSlide).addClass("active");
		if ((CurrentSlide + 1) === slick.$slides.length) {
			$('.count li').eq(0).addClass("done");
			$('.big-count li').eq(0).addClass("done");
		} else {
			$('.count li').eq(CurrentSlide).next().addClass("done");
			$('.big-count li').eq(CurrentSlide).next().addClass("done");

		}
		$('.slick-slide').find('.move').removeClass('move');
        $('.slide-overlay').removeClass('active');
        $('.item').removeClass('active');

        //If the slide overlay has been moving forwards, add the class forwards--after to handle animation moving back.
        if ($('.slide-overlay').hasClass('forwards')) {
            $('.slide-overlay').removeClass('forwards');
            $('.slide-overlay').addClass('forwards--after');
        }
        //If the slide overlay has been moving backwards, add the class backwards--after to handle animation moving back.
        if ($('.slide-overlay').hasClass('backwards')) {
            $('.slide-overlay').removeClass('backwards');
            $('.slide-overlay').addClass('backwards--after');
        }
	}
    private handleBeforeChange(slick, currentSlide, nextSlide) {
		$('.slide-overlay').addClass('active');
        $('.slick-current').find('.item-text__headline').addClass('move');
        $('.slide-overlay').removeClass('backwards--after');
        $('.slide-overlay').removeClass('forwards--after');

        let movingForwards: boolean = false;

        //Set moving forwards to true, if  moving from last to first of slick slideshow
        if (currentSlide === slick.$slides.length - 1 && nextSlide === 0) {
            movingForwards = true;
        }
        //Set moving forwards to false, if moving from first to last
        else if (currentSlide === 0 && nextSlide === slick.$slides.length -1) {
            movingForwards = false;
        }
        //Set movingforwards to true - if next slide index is larger than the current
        else if (currentSlide < nextSlide) {
            movingForwards = true;
        }
        //Set moving forwards to false, if next slide is smaller than the current.
        else if (nextSlide < currentSlide) {
            movingForwards = false;
        }

        if (movingForwards) {
            $('.slide-overlay').addClass('forwards');
        }
        else if (movingForwards == false) {
            $('.slide-overlay').addClass('backwards');
        }

	}

	//if needed without vue can methods be converted to plain jquery, events can be seen here: https://kenwheeler.github.io/slick/
	//any questions, ask Anders Bootsmann.
	
}
